import React, {useState} from "react";
import {signin} from "../../../api/authApi";
import LoginForm from "./LoginForm";
import "./login.css";
import PopupSpinner from "../../molecules/spinner/PopupSpinnerView";
import {ConfirmCodeApiResponse} from "../../../api/apiTypes";
import {useDispatch} from "react-redux";
import {TApiError, showApiError} from "../../../common/message";
import {AxiosError} from "axios";
import {TokenStorage} from "../../../services/token.service";
import {updateAuthenticated} from "../../../reducers/authReducer";
import {getUser} from "../../../api/userApi";
import {updateProfile} from "../../../reducers/profileReducer";
import {useNavigate} from "react-router-dom";
import {Layout, message} from "antd";

const LoginScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  
  const [loading, setLoading] = useState(false);
  
  const handleSignin = (username: string, password: string) => {
    setLoading(true);
    signin(username, password, onPhoneVerified, onError);
  };
  
  const onError = (err: AxiosError<TApiError>) => {
    showApiError(err, messageApi);
    setLoading(false);
  };
  
  const onPhoneVerified = (data: ConfirmCodeApiResponse) => {
    TokenStorage.storeToken(data.access);
    TokenStorage.storeRefreshToken(data.refresh);
    getUser((pro) => {
      dispatch(updateProfile(pro));
    }, (error) => {
      showApiError(error, messageApi)
    });
    navigate('/main/guide');
    dispatch(updateAuthenticated(true));
  };
  
  return (<Layout className={"login"}>
    {contextHolder}
    <LoginForm onSignin={handleSignin} />
    {loading && <PopupSpinner />}
  </Layout>);
};

export default LoginScreen;
